export default __webpack_public_path__ + "static/media/epfoValidateOTP.5386681d.png";